import React, { useState } from "react";
import { ethers } from "ethers";

const WalletConnectButton = ({ onWalletConnected }) => {
  const [connected, setConnected] = useState(false);
  const [address, setAddress] = useState("");

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        const accounts = await provider.send("eth_requestAccounts", []);
        const walletAddress = accounts[0];
        setAddress(walletAddress);
        setConnected(true);
        onWalletConnected(walletAddress);
      } catch (error) {
        console.error("Error connecting wallet:", error);
      }
    } else {
      alert("MetaMask is not installed. Please install it to use this app.");
    }
  };

  return (
    <button
      onClick={connectWallet}
      className="px-6 py-3 text-white bg-blue-500 rounded-lg hover:bg-blue-600"
    >
      {connected ? `Connected: ${address.slice(0, 6)}...${address.slice(-4)}` : "Connect Wallet"}
    </button>
  );
};

export default WalletConnectButton;
